// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Gadget Loan / CIBIL Check Styles
   ========================================== */

.cibil-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 6rem 1.5rem 3rem 1.5rem;
}

.cibil-header {
  text-align: center;
  margin-bottom: 3rem;
  padding: 2.5rem 2rem;
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-glass);
}

.cibil-title {
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.cibil-subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
}

.cibil-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  position: relative;
  padding-bottom: 5rem;
}

.cibil-content .submit-btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 240px;
  height: 52px;
  border-radius: var(--radius-full);
  background: var(--grad-primary);
  color: #ffffff;
  font-weight: 700;
  font-size: 1rem;
  border: none;
  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cibil-content .submit-btn:hover {
  transform: translateX(-50%) translateY(-2px);
  box-shadow: 0 8px 30px rgba(245, 158, 11, 0.6);
}

.cibil-form-section {
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  padding: 2rem;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-glass);
}

.form-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-glass);
}

.form-icon {
  background: rgba(245, 158, 11, 0.15);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-shield {
  color: #818cf8;
  font-size: 1.5rem;
}

.form-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
}

.form-subtitle {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.cibil-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
  padding-left: 0.75rem;
  border-left: 3px solid var(--color-primary);
  margin-bottom: 0.75rem;
}

.input-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}

.input-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.input-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #cbd5e1;
}

.input-icon-svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  font-size: 1rem;
}

.cibil-input {
  width: 100%;
  padding: 0.75rem 0.75rem 0.75rem 2.25rem;
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-sm);
  color: #ffffff;
  outline: none;
  transition: all 0.3s ease;
}

.cibil-input:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.25);
}

.error-text {
  color: var(--color-danger);
  font-size: 0.75rem;
}

.toast {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.85rem 1.75rem;
  border-radius: var(--radius-full);
  color: #ffffff;
  font-weight: 600;
  z-index: 1000;
  box-shadow: var(--shadow-lg);
}

.toast.success { background-color: var(--color-emerald); }
.toast.error { background-color: var(--color-danger); }

@media (max-width: 992px) {
  .cibil-content {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Cibill.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,4BAA4B;AAC9B;;AAEA,iBAAiB,sCAAsC,EAAE;AACzD,eAAe,qCAAqC,EAAE;;AAEtD;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Gadget Loan / CIBIL Check Styles\n   ========================================== */\n\n.cibil-container {\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 6rem 1.5rem 3rem 1.5rem;\n}\n\n.cibil-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 2.5rem 2rem;\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-glass);\n}\n\n.cibil-title {\n  font-size: clamp(2rem, 4vw, 2.75rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.cibil-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n}\n\n.cibil-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  position: relative;\n  padding-bottom: 5rem;\n}\n\n.cibil-content .submit-btn {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 240px;\n  height: 52px;\n  border-radius: var(--radius-full);\n  background: var(--grad-primary);\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 1rem;\n  border: none;\n  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cibil-content .submit-btn:hover {\n  transform: translateX(-50%) translateY(-2px);\n  box-shadow: 0 8px 30px rgba(245, 158, 11, 0.6);\n}\n\n.cibil-form-section {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  padding: 2rem;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-glass);\n}\n\n.form-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-glass);\n}\n\n.form-icon {\n  background: rgba(245, 158, 11, 0.15);\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-shield {\n  color: #818cf8;\n  font-size: 1.5rem;\n}\n\n.form-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.form-subtitle {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.cibil-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.section-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #ffffff;\n  padding-left: 0.75rem;\n  border-left: 3px solid var(--color-primary);\n  margin-bottom: 0.75rem;\n}\n\n.input-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.25rem;\n}\n\n.input-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.input-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #cbd5e1;\n}\n\n.input-icon-svg {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n  font-size: 1rem;\n}\n\n.cibil-input {\n  width: 100%;\n  padding: 0.75rem 0.75rem 0.75rem 2.25rem;\n  background: rgba(15, 23, 42, 0.7);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-sm);\n  color: #ffffff;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.cibil-input:focus {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.25);\n}\n\n.error-text {\n  color: var(--color-danger);\n  font-size: 0.75rem;\n}\n\n.toast {\n  position: fixed;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 0.85rem 1.75rem;\n  border-radius: var(--radius-full);\n  color: #ffffff;\n  font-weight: 600;\n  z-index: 1000;\n  box-shadow: var(--shadow-lg);\n}\n\n.toast.success { background-color: var(--color-emerald); }\n.toast.error { background-color: var(--color-danger); }\n\n@media (max-width: 992px) {\n  .cibil-content {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
